import { Route, Routes } from 'react-router-dom';
import AlarmGroupsList from './alarm-groups-list/AlarmGroupsList';
import AlarmGroupDetailsRoot from './alarm-group-details/AlarmGroupDetailsRoot';

export function AlarmGroupsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AlarmGroupsList />} />
      <Route path=":alarmGroupId" element={<AlarmGroupDetailsRoot />} />
    </Routes>
  );
}

export default AlarmGroupsRoutes;
